import React from 'react';
import PropTypes from 'prop-types';

import { TextPStyled, TextSpanStyled, TextDivStyled } from './TextStyled';

export default function Text({ element, children, className, id }) {
  let elementSwitched;

  switch (element) {
    case 'p':
    default:
      elementSwitched = (
        <TextPStyled className={className} id={id}>{children}</TextPStyled>
      );
      break;
    case 'span':
      elementSwitched = (
        <TextSpanStyled className={className} id={id}>{children}</TextSpanStyled>
      );
      break;
    case 'div':
      elementSwitched = (
        <TextDivStyled className={className} id={id}>{children}</TextDivStyled>
      );
      break;
  }

  return elementSwitched;
}

Text.propTypes = {
  element: PropTypes.string,
};

Text.defaultProps = {
  element: 'p',
};
